// extracted by mini-css-extract-plugin
export default {"wrapper":"preloadimage_wrapper__gu+19","spacer":"preloadimage_spacer__ZSF57"};